import * as reviewReportTypes from "./reviewReportType";

const ReviewReportTypes = {
  list() {
    return Object.keys(reviewReportTypes);
  },
  getAll() {
    return this.list().map(reviewReportType => {
      return {
        value: reviewReportType,
        text: reviewReportType
      };
    });
  }
};

export default ReviewReportTypes;
